import { PeerGamingApiSlice } from '../PeerGamingApiSlice';

export const reviewSlice = PeerGamingApiSlice.injectEndpoints({
	endpoints(builder) {
		return {
			fetchReviews: builder.query<
				Review[],
				| {
						reviewId?: number;
						gameId?: number;
						username?: string;
						count?: number;
				  }
				| undefined
			>({
				query: (request) => ({
					url: '/reviews',
					params: {
						id: request?.reviewId,
						videoGameId: request?.gameId,
						playerUsername: request?.username,
						selectCount: request?.count
					}
				}),
				providesTags: ['Reviews']
			}),

			addReview: builder.mutation<Review, AddReviewRequest>({
				query: (payload) => ({
					url: '/Reviews',
					method: 'POST',
					body: payload
				}),
				invalidatesTags: ['Reviews']
			}),

			fetchHighlights: builder.query<HighlightType[], undefined>({
				query: () => ({
					url: '/Reviews/Highlights'
				}),
				providesTags: ['Highlights']
			})
		};
	}
});

export const {
	useFetchReviewsQuery,
	useLazyFetchReviewsQuery,
	useAddReviewMutation,
	useFetchHighlightsQuery
} = reviewSlice;

export interface ReviewListItem {
	id: number;
	rating: number;
	title: string;
	recommended: boolean;
	username: string;
	videoGameTitle: string;
	platformName: string;
}

export interface Review {
	id: number;
	rating: number;
	title: string;
	body?: string;
	recommended: boolean;
	createDate: string;
	modifiedDate?: string;
	username: string;
	videoGameId: number;
	videoGameTitle: string;
	platformName: string;
	highlights: Highlight[];
	videoGameBoxArt: string;
}

export interface Highlight {
	name: string;
	rating: number;
}

export interface HighlightType {
	highlight: string;
	description: string;
}

export interface AddReviewRequest {
	id: number;
	rating: number;
	title: string;
	body?: string | undefined;
	recommended?: boolean | undefined;
	playerUsername: string;
	platformName: string;
	videoGameTitle: string;
	highlights?: AddHighlightRequest[] | undefined;
}

export interface AddHighlightRequest {
	highlight: string;
	rating: number;
}
